<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
	import {
		useStore
	} from "vuex";
import { sessionStorage } from "@/utils/sessionStorage";
	export default {
		name: "app",
// 		errorCaptured(message) {
//     console.error('vue component error', message)
//   },
		setup() {
			const store = useStore();
			 if (window.sessionStorage.getItem("user")) {
      store.state.user = sessionStorage.get("user");
    }
			// 在页面加载时读取sessionStorage里的状态信息
		// 	if (sessionStorage.getItem('GZEUA_USER')) {
		// 	console.info("loaded store",sessionStorage.getItem('GZEUA_USER'))
		// 		// 存储状态
			
		// const stateObj=JSON.parse(sessionStorage.getItem('GZEUA_USER'))
		// store.commit('user/setUserInfo', stateObj.userInfo)
		// store.commit('user/setUserMenu', stateObj.userMenu)
		// 	}
			// 在页面刷新时将vuex里的信息保存到sessionStorage里
			// window.addEventListener('pagehide', () => {
			// 	sessionStorage.setItem('GZEUA_USER', JSON.stringify(store.state))
			// 	console.info('store to save',store.state)
			// })
		}
	}
</script>
<style lang="scss">

	#app {
		font-family: Avenir, Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		
		color: #2c3e50;
	}

	#nav {
		padding: 30px;
	}

	#nav a {
		font-weight: bold;
		color: #2c3e50;
	}

	#nav a.router-link-exact-active {
		color: #42b983;
	}

	body {
		margin: 0;
	}

	.el-menu .el-menu-item.is-active {
		background-color: none !important
	}

	:root {
		--el-color-primary: #15ae6d;
	}

	.el-button--primary {
		--el-button-font-color: #ffffff;
		--el-button-background-color: #15ae6d;
		--el-button-border-color: #15ae6d;
		--el-button-hover-color: #15ae6d;
		--el-button-active-font-color: #e6e6e6;
		--el-button-active-background-color: #15ae6d;
		--el-button-active-border-color: #15ae6d;
	}
</style>
